module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-Italic.c79c02ef.woff2";